var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "slideContainer", staticClass: "profitability" },
    [
      _c("Title", { attrs: { zhTitle: "盈利能力", enTitle: "Profitability" } }),
      _vm.types == 1
        ? _c("div", { staticClass: "cards1" }, [
            _vm.array[0] === 1
              ? _c("div", { staticClass: "card" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("销售费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.xsfyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.xsfylUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Selling Expense Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.xsfyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.xsfyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.xsfylUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart1", staticClass: "charts" }),
                ])
              : _vm._e(),
            _vm.array[1] === 1
              ? _c("div", { staticClass: "card" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("管理费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.glfyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.glfylUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Administrative Expense Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.glfyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.glfyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.glfylUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart2", staticClass: "charts" }),
                ])
              : _vm._e(),
            _vm.array[2] === 1
              ? _c("div", { staticClass: "card" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("财务费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.cwfyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.cwfylUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Financial Expense Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.cwfyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.cwfyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.cwfylUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart3", staticClass: "charts" }),
                ])
              : _vm._e(),
            _vm.array[3] === 1
              ? _c("div", { staticClass: "card" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("研发费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.yffyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.yffylUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("R&D Rate"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.yffyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.yffyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.yffylUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart4", staticClass: "charts" }),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.types == 2
        ? _c("div", { staticClass: "cards" }, [
            _vm.array[0] === 1
              ? _c("div", { staticClass: "card2" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("销售费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.xsfyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.xsfylUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Selling Expense Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.xsfyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.xsfyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.xsfylUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart1", staticClass: "charts2" }),
                ])
              : _vm._e(),
            _vm.array[1] === 1
              ? _c("div", { staticClass: "card2" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("管理费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.glfyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.glfylUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Administrative Expense Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.glfyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.glfyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.glfylUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart2", staticClass: "charts2" }),
                ])
              : _vm._e(),
            _vm.array[2] === 1
              ? _c("div", { staticClass: "card2" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("财务费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.cwfyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.cwfylUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Financial Expense Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.cwfyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.cwfyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.cwfylUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart3", staticClass: "charts2" }),
                ])
              : _vm._e(),
            _vm.array[3] === 1
              ? _c("div", { staticClass: "card2" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("研发费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.yffyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.yffylUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("R&D Rate"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.yffyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.yffyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.yffylUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart4", staticClass: "charts2" }),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.types == 3
        ? _c("div", { staticClass: "cards" }, [
            _vm.array[0] === 1
              ? _c("div", { staticClass: "card3" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("销售费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.xsfyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.xsfylUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Selling Expense Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.xsfyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.xsfyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.xsfylUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart1", staticClass: "charts3" }),
                ])
              : _vm._e(),
            _vm.array[1] === 1
              ? _c("div", { staticClass: "card3" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("管理费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.glfyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.glfylUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Administrative Expense Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.glfyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.glfyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.glfylUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart2", staticClass: "charts3" }),
                ])
              : _vm._e(),
            _vm.array[2] === 1
              ? _c("div", { staticClass: "card3" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("财务费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.cwfyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.cwfylUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Financial Expense Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.cwfyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.cwfyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.cwfylUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart3", staticClass: "charts3" }),
                ])
              : _vm._e(),
            _vm.array[3] === 1
              ? _c("div", { staticClass: "card3" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("研发费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.yffyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.yffylUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("R&D Rate"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.yffyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.yffyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.yffylUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart4", staticClass: "charts3" }),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.types == 4
        ? _c("div", { staticClass: "cards4" }, [
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "card4" }, [
                _vm.language === "zh"
                  ? _c(
                      "div",
                      { staticClass: "zh", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("销售费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n            " + _vm._s(_vm.xsfyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.xsfylUnit)),
                          ]),
                        ]),
                      ]
                    )
                  : _vm.language === "en"
                  ? _c(
                      "div",
                      { staticClass: "en", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Selling Expense Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.xsfyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n            " + _vm._s(_vm.xsfyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.xsfylUnit)),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "line" }),
                _c("div", { ref: "chart1", staticClass: "charts4" }),
              ]),
              _c("div", { staticClass: "card4" }, [
                _vm.language === "zh"
                  ? _c(
                      "div",
                      { staticClass: "zh", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("管理费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n            " + _vm._s(_vm.glfyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.glfylUnit)),
                          ]),
                        ]),
                      ]
                    )
                  : _vm.language === "en"
                  ? _c(
                      "div",
                      { staticClass: "en", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Administrative Expense Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.glfyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n            " + _vm._s(_vm.glfyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.glfylUnit)),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "line" }),
                _c("div", { ref: "chart2", staticClass: "charts4" }),
              ]),
            ]),
            _c("div", { staticClass: "column mt" }, [
              _c("div", { staticClass: "card4" }, [
                _vm.language === "zh"
                  ? _c(
                      "div",
                      { staticClass: "zh", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("财务费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n            " + _vm._s(_vm.cwfyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.cwfylUnit)),
                          ]),
                        ]),
                      ]
                    )
                  : _vm.language === "en"
                  ? _c(
                      "div",
                      { staticClass: "en", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Financial Expense Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.cwfyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n            " + _vm._s(_vm.cwfyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.cwfylUnit)),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "line" }),
                _c("div", { ref: "chart3", staticClass: "charts4" }),
              ]),
              _c("div", { staticClass: "card4" }, [
                _vm.language === "zh"
                  ? _c(
                      "div",
                      { staticClass: "zh", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("研发费用率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n            " + _vm._s(_vm.yffyl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.yffylUnit)),
                          ]),
                        ]),
                      ]
                    )
                  : _vm.language === "en"
                  ? _c(
                      "div",
                      { staticClass: "en", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("R&D Rate"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.yffyl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n            " + _vm._s(_vm.yffyl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.yffylUnit)),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "line" }),
                _c("div", { ref: "chart4", staticClass: "charts4" }),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }